import styled, { css } from 'styled-components'

/*
 * The type scale of every dashboard widget, old and new. A widget takes its
 * sizes from here and nowhere else, so a title on a list card and a title on a
 * chart card are the same title.
 *
 *   title     the card's name
 *   subtitle  the line under it — period, context
 *   hero      the one figure a card leads with; grows with the card's width
 *   value     a figure in a row of KPIs or a totals box
 *   label     what a figure is; table headers
 *   body      list rows, table cells, legends, feed entries
 *   caption   small print — timestamps, secondary figures, tooltips' detail
 *   badge     status pills
 *
 * `widgetSize` is the scale itself; `widgetFont` the same sizes as styled
 * snippets with their weight and line height, which is what a styled component
 * should use. `chartFont` is in pixels, for the SVG text recharts draws (tick
 * and value labels), which takes a number rather than CSS.
 *
 * `hero` is sized in `cqi` — a share of the card's own width — which needs a
 * size container around it. GridWidget makes every grid cell one.
 */
export const widgetSize = {
    title:    '1.2rem',
    subtitle: '0.9rem',
    hero:     'clamp(1.9rem, 9cqi, 2.6rem)',
    value:    '1.5rem',
    label:    '0.875rem',
    body:     '0.95rem',
    caption:  '0.8rem',
    badge:    '0.75rem',
}

export const widgetFont = {
    title:    css`font-size: ${widgetSize.title};    font-weight: 600; line-height: 1.3;`,
    subtitle: css`font-size: ${widgetSize.subtitle}; font-weight: 400; line-height: 1.35;`,
    hero:     css`font-size: ${widgetSize.hero};     font-weight: 700; line-height: 1.1; letter-spacing: -0.01em; font-variant-numeric: tabular-nums;`,
    value:    css`font-size: ${widgetSize.value};    font-weight: 700; line-height: 1.2; font-variant-numeric: tabular-nums;`,
    label:    css`font-size: ${widgetSize.label};    font-weight: 500; line-height: 1.35;`,
    body:     css`font-size: ${widgetSize.body};     font-weight: 400; line-height: 1.4;`,
    caption:  css`font-size: ${widgetSize.caption};  font-weight: 400; line-height: 1.35;`,
    badge:    css`font-size: ${widgetSize.badge};    font-weight: 600; line-height: 1.4;`,
}

export const chartFont = {
    tick: 12,
    label: 12,
}

// The heading every widget opens with. The bottom margin is the one the global
// h2/h3 gave the widgets that used them, so their spacing stays as it was.
export const WidgetTitle = styled.h3`
    margin: 0 0 0.5rem;
    color: ${p => p.theme.font.color};
    ${widgetFont.title}
`
